export default __webpack_public_path__ + "static/media/neoito-logo.cefa7051.svg";